import { getNames, isConditionOfType } from "app/pages/sales-intelligence/sub-modules/advanced-search/helpers/technologies";
import type {
    TechnologiesConditionEntry } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";
import {
    TechnologiesConditionTypeEnum,
} from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";
import type TechnologySignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalFilters";
import { entryToFilterTypeMap } from "./const";

export const buildFilterFromEntries = (
    entries: ReadonlyArray<TechnologiesConditionEntry>,
): Partial<TechnologySignalFilters> => {
    let filter = {};
    const types = Object.values(TechnologiesConditionTypeEnum);

    for (const type of types) {
        const filterKey = entryToFilterTypeMap[type];
        const entriesByType = entries.filter(isConditionOfType(type));

        filter = {
            ...filter,
            [filterKey]: getNames(entriesByType),
        };
    }

    return filter;
};
